<template>
	<div class="content-module-container">
		<MStateBox :loading="custom.loading" :empty="isEmpty">
			<div class="card-wrap">
				<div v-for="(item, index) in moduleList" :key="index" class="file-item" @click="handlePreview(item)">
					<div class="file-cover">
						<img v-if="item.logoUrl" :src="item.logoUrl" alt="" />
						<div v-else class="empty-cover"></div>
					</div>
					<div class="file-title">{{ item.subject }}</div>
				</div>
			</div>
			<el-pagination
				@size-change="changePageSize"
				@current-change="changeCurrentPage"
				:current-page="currentPage"
				:page-sizes="pageSizes"
				:page-size="pageSize"
				:layout="pageLayout"
				:total="pageTotal"
				hide-on-single-page
				background
			></el-pagination>
		</MStateBox>
	</div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { usePaginationPC } from '@rebuild/hooks/load-more/usePaginationPC';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCustomCore } from '@rebuild/materials/shared/custom/context';
import { isBuild } from '@/const/host';

const getModuleId = computed(() => (isBuild ? 186 : 354)); //生产环境模块id 186 测试环境模块id 354

// 数据层
const { custom } = useModuleData();

const isEmpty = computed(() => !custom.data?.rows?.length || custom.empty);

// 保持与历史组件相同的数据访问路径：data.rows
const moduleList = ref([]);
const initModuleList = async () => {
	if (!getModuleId.value) return;

	const params = {
		title: '',
		moduleId: getModuleId.value,
		pageStart: currentPage.value - 1,
		pageNum: pageSize.value
	};

	await custom.refresh(params);
	custom.data?.rows?.forEach(item => {
		item.title = item.subject;
		item.time = item.contentTime;
	});
	moduleList.value = custom.data?.rows || [];

	changePageTotal(custom.data?.total || 0);
};

const handlePaginationChange = () => {
	initModuleList();
};

// 统一PC端分页处理
const { currentPage, pageSize, pageSizes, pageLayout, pageTotal, changePageSize, changeCurrentPage, changePageTotal } =
	usePaginationPC({
		bindChange: handlePaginationChange
	});

const headerTitle = ref('');

const { findModule } = useCustomCore();

const { viewModule } = useModuleNavigation();
const handlePreview = item => {
	viewModule('custom', item, headerTitle.value);
};

onMounted(async () => {
	const findModuleData = findModule(getModuleId.value);
	if (findModuleData?.name) {
		headerTitle.value = findModuleData.name;
	}

	await initModuleList();
});
</script>

<style lang="less" scoped>
.content-module-container {
	.custom-title {
		color: #1d2129;

		font-size: 24px;

		font-weight: 500;
		line-height: 140%;
	}
}
.searchWrap {
	display: flex;
	justify-content: space-between;
	padding-bottom: 53px;
}
.card-wrap {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: 16px;
	.file-item {
		box-sizing: content-box;
		width: calc((100% - 152px) / 4);
		padding: 12px;
		border-radius: 2px;
		border: 1px solid #f2f3f5;
		background: #fff;
		cursor: pointer;
		transition: all 0.18s ease-in-out;
		&:hover {
			box-shadow: 1px 4px 16px 0px rgba(0, 0, 0, 0.08);
			backdrop-filter: blur(7px);
		}
	}
	.file-cover {
		position: relative;
		width: 100%; // 容器宽度由父级决定
		padding-bottom: calc(267 / 213 * 100%); // 高度相对于宽度的比例
		border: 1px solid #f2f3f5;

		img,
		.empty-cover {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
		img {
			object-fit: cover;
		}
	}

	.file-title {
		margin-top: 12px;
		color: #1d2129;
		font-size: 14px;
		font-weight: 500;
		line-height: 18px; /* 128.571% */
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
